
export const DEFAULT_LOCALE = 'zh-TW'
export const DEFAULT_LOCALE_PATH = 'tw'

export const LOCALE_LIST = [
  {
    countryCode: 'us',
    languageCode: 'en',
    locale: 'en-US',
    label: 'English',
    htmlLang: 'en'
  },
  {
    countryCode: 'tw',
    languageCode: 'zh',
    locale: 'zh-TW',
    label: '繁體中文',
    htmlLang: 'zh-Hant'
  },
  {
    countryCode: 'cn',
    languageCode: 'zh',
    locale: 'zh-CN',
    label: '简体中文',
    htmlLang: 'zh-Hans'
  },
  {
    countryCode: 'jp',
    languageCode: 'ja',
    locale: 'ja-JP',
    label: '日本語',
    htmlLang: 'ja'
  }
]
